import React from 'react';
import { useTranslation } from 'react-i18next';

function ProfileEmailRevealModal({
  isOpen,
  maskedEmail,
  title,
  currentLabel,
  currentValue,
  reasonLabel,
  savingLabel,
  submitLabel,
  currentInputId = 'profile-email-reveal-current',
  reasonInputId = 'profile-email-reveal-reason',
  form,
  errors,
  isSaving,
  onChange,
  onClose,
  onSave,
}) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-dialog">
        <form className="modal-content" onSubmit={onSave}>
          <div className="modal-header">
            <h5 className="modal-title">{title || t('profiles.revealEmail')}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label={t('common.cancel')}
              onClick={onClose}
              disabled={isSaving}
            ></button>
          </div>
          <div className="modal-body">
            {errors.form ? <div className="alert alert-danger py-2">{errors.form}</div> : null}

            <div className="mb-3">
              <label className="form-label" htmlFor={currentInputId}>{currentLabel || t('profiles.currentEmail')}</label>
              <input id={currentInputId} type="text" className="form-control" value={currentValue ?? maskedEmail ?? ''} disabled />
            </div>
            <div className="mb-0">
              <label className="form-label" htmlFor={reasonInputId}>{reasonLabel || t('profiles.emailRevealReason')}</label>
              <textarea
                id={reasonInputId}
                className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
                value={form.reason}
                onChange={(event) => onChange('reason', event.target.value)}
                rows={3}
                maxLength={512}
                disabled={isSaving}
              />
              {errors.reason ? <div className="invalid-feedback">{errors.reason}</div> : null}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={onClose} disabled={isSaving}>
              {t('common.cancel')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={isSaving}>
              {isSaving ? (savingLabel || t('profiles.revealingEmail')) : (submitLabel || t('profiles.revealEmail'))}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProfileEmailRevealModal;
